import Login from './auth/Login.svelte';

const login = new Login({
  target: document.body,
});

export default login;